import { render, staticRenderFns } from "./vidclbanner.vue?vue&type=template&id=5d9c3c5e&"
import script from "./vidclbanner.vue?vue&type=script&lang=js&"
export * from "./vidclbanner.vue?vue&type=script&lang=js&"
import style0 from "./vidclbanner.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports